export interface IEstabEquipamento {
    id: string;
    idTipoEquipamento: string;
    tipoEquipamento: string;
    idEquipamento: string;
    equipamento: string;
    equipamentoObj: any;
    quantidadeExistente: number;
    quantidadeUso: number;
    sus: number;
}

export class EstabEquipamentoModel {
    id: string;
    idTipoEquipamento: string;
    tipoEquipamento: string;
    idEquipamento: string;
    equipamento: string;
    equipamentoObj: any;
    quantidadeExistente: number;
    quantidadeUso: number;
    sus: number;


    constructor(obj: IEstabEquipamento) {
        this.id = obj.id ? obj.id : '';
        this.idTipoEquipamento = obj.idTipoEquipamento ? obj.idTipoEquipamento : '';
        this.tipoEquipamento = obj.tipoEquipamento ? obj.tipoEquipamento : '';
        this.idEquipamento = obj.idEquipamento ? obj.idEquipamento : '';
        this.equipamento = obj.equipamento ? obj.equipamento : '';
        this.quantidadeExistente = obj.quantidadeExistente ? obj.quantidadeExistente : 0;
        this.quantidadeUso = obj.quantidadeUso ? obj.quantidadeUso : 0;
        this.sus = obj.sus ? obj.sus : 0;
        this.equipamentoObj = obj.equipamentoObj ? obj.equipamentoObj : {};
    }
}

export class EstabEquipamentoSaveModel {
    codigoEquipamento: any;
    quantidade: number;

    constructor(obj: IEstabEquipamento) {
        this.codigoEquipamento = obj.idTipoEquipamento ? obj.idTipoEquipamento : '';
        this.quantidade = obj.quantidadeExistente ? obj.quantidadeExistente : 0;
    }
}
